<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>

export default {
  name: "App",
  components: {},
  data() {
    return {
      color: sessionStorage.getItem("color"),
    };
  },
  created() {
    window.addEventListener(
      "mousewheel",
      function (event) {
        if (event.ctrlKey === true || event.metaKey) {
          event.preventDefault();
        }
      },
      { passive: false }
    );

    // document.documentElement.style.setProperty(
    //   "--el-color-primary",
    //   this.color
    // );
    // for (let i = 1; i <= 9; i++) {
    //   document.documentElement.style.setProperty(
    //     `--el-color-primary-light-${i}`,
    //     colorTool.lighten(this.color, i / 10)
    //   );
    // }
    // for (let i = 1; i <= 9; i++) {
    //   document.documentElement.style.setProperty(
    //     `--el-color-primary-dark-${i}`,
    //     colorTool.darken(this.color, i / 10)
    //   );
    // }
  },
};
</script>

<style>
#app {
}
</style>
